import infoBarMessageCreatorsMap from '../utils/infoBarMessageCreatorsMap';
import { action } from 'satcheljs/lib/legacy';
var removeInfoBarMessageInReadingPane = action('removeInfoBarMessageInReadingPane')(function removeInfoBarMessageInReadingPane(viewState, messageId) {
    for (var i = 0; i < viewState.infoBarIds.length; i++) {
        if (viewState.infoBarIds[i] == messageId) {
            viewState.infoBarIds.splice(i, 1);
            break;
        }
    }
    if (infoBarMessageCreatorsMap[viewState.itemId]) {
        delete infoBarMessageCreatorsMap[viewState.itemId][messageId];
        if (Object.keys(infoBarMessageCreatorsMap[viewState.itemId]).length === 0) {
            delete infoBarMessageCreatorsMap[viewState.itemId];
        }
    }
});
export default removeInfoBarMessageInReadingPane;
//# sourceMappingURL=removeInfoBarMessageInReadingPane.js.map